import React, { ReactNode } from 'react';
import infoSvg from 'assets/images/icons/info-blue.svg';
import styles from './InfoBlock.module.scss'

type Props = {
  content: ReactNode;
};

const InfoBlock = ({ content }: Props) => (
  <div className={styles.container}>
    <div className={styles.row}>
      <img src={infoSvg} width="24px" alt="info" />
      <p className={styles.heading}>Info</p>
    </div>
    <div className={styles.body}>
      {content}
    </div>
  </div>
);

export default InfoBlock;
